<ngx-loading-bar [includeSpinner]="false"></ngx-loading-bar>
<router-outlet></router-outlet>
<span style="font-size: 0.8rem;" class="footer">v{{version}}</span>



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/app.component.html